export const calendarTranslations = {
  en: {
    title: "Calendar",
    subtitle: "Manage your schedule, appointments, and events",
    newEvent: "New Event",
    createEvent: "Create New Event",
    editEvent: "Edit Event",
    eventDetails: "Event Details",
    delete: "Delete",
    edit: "Edit",
    cancel: "Cancel",
    save: "Save",
    deleteConfirmation: {
      title: "Delete Event",
      message: "Are you sure you want to delete this event? This action cannot be undone.",
      confirm: "Delete",
      cancel: "Cancel"
    },
    calendarSources: "Calendar Sources",
    crmCalendar: "CRM Calendar",
    googleCalendar: "Google Calendar",
    googleCalendarInfo: "Google Calendar events can only be edited in Google Calendar",
    allDay: "All day on",
    location: "Location",
    from: "From",
    description: "Description",
    date: "Date",
    startTime: "Start Time",
    endTime: "End Time",
    allDayEvent: "All day event",
    eventTitle: "Event Title",
    eventCreated: "Event created successfully",
    eventUpdated: "Event updated successfully",
    eventDeleted: "Event deleted successfully",
    failedToCreate: "Failed to create event",
    failedToUpdate: "Failed to update event",
    failedToDelete: "Failed to delete event",
    errorLoadingEvents: "Error loading events",
    errorLoadingGoogleEvents: "Error loading Google events",
    localEventsAvailable: "Local calendar events are still available",
    noEvents: "No events scheduled for this day",
    eventsFor: "Events for",
    monthView: "Month",
    weekView: "Week",
    dayView: "Day",
    listView: "List",
    active: "active",
    view: "View",
    today: "Today",
    previousPeriod: "Previous",
    nextPeriod: "Next",
    toggleSidebar: "Toggle sidebar",
    showSidebar: "Show events sidebar",
    hideSidebar: "Hide events sidebar",
    refreshingCalendar: "Refreshing calendar data...",
    loadingGoogleCalendars: "Loading Google calendars...",
    googleCalendarsLoaded: "Google calendars loaded",
    loadingGoogleEvents: "Loading Google events...",
    googleEventsLoaded: "Google events loaded"
  },
  it: {
    title: "Calendario",
    subtitle: "Gestisci il tuo programma, appuntamenti ed eventi",
    newEvent: "Nuovo Evento",
    createEvent: "Crea Nuovo Evento",
    editEvent: "Modifica Evento",
    eventDetails: "Dettagli Evento",
    delete: "Elimina",
    edit: "Modifica",
    cancel: "Annulla",
    save: "Salva",
    deleteConfirmation: {
      title: "Elimina Evento",
      message: "Sei sicuro di voler eliminare questo evento? Questa azione non può essere annullata.",
      confirm: "Elimina",
      cancel: "Annulla"
    },
    calendarSources: "Sorgenti Calendario",
    crmCalendar: "Calendario CRM",
    googleCalendar: "Google Calendar",
    googleCalendarInfo: "Gli eventi di Google Calendar possono essere modificati solo in Google Calendar",
    allDay: "Tutto il giorno il",
    location: "Luogo",
    from: "Da",
    description: "Descrizione",
    date: "Data",
    startTime: "Ora Inizio",
    endTime: "Ora Fine",
    allDayEvent: "Evento tutto il giorno",
    eventTitle: "Titolo Evento",
    eventCreated: "Evento creato con successo",
    eventUpdated: "Evento aggiornato con successo",
    eventDeleted: "Evento eliminato con successo",
    failedToCreate: "Impossibile creare l'evento",
    failedToUpdate: "Impossibile aggiornare l'evento",
    failedToDelete: "Impossibile eliminare l'evento",
    errorLoadingEvents: "Errore nel caricamento degli eventi",
    errorLoadingGoogleEvents: "Errore nel caricamento degli eventi Google",
    localEventsAvailable: "Gli eventi del calendario locale sono ancora disponibili",
    noEvents: "Nessun evento programmato per questo giorno",
    eventsFor: "Eventi del",
    monthView: "Mese",
    weekView: "Settimana",
    dayView: "Giorno",
    listView: "Lista",
    active: "attivi",
    view: "Vista",
    today: "Oggi",
    previousPeriod: "Precedente",
    nextPeriod: "Successivo",
    toggleSidebar: "Attiva/Disattiva barra laterale",
    showSidebar: "Mostra eventi laterali",
    hideSidebar: "Nascondi eventi laterali",
    refreshingCalendar: "Aggiornamento calendario in corso...",
    loadingGoogleCalendars: "Caricamento calendari Google...",
    googleCalendarsLoaded: "Calendari Google caricati",
    loadingGoogleEvents: "Caricamento eventi Google...",
    googleEventsLoaded: "Eventi Google caricati"
  }
};